import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays the free-shipping progress meter on the
 * product page. It mirrors whatever is actually in the customer's cart, so
 * whenever the cart changes anywhere on the page (add to cart, cart drawer,
 * quick add, etc.) it re-fetches its own markup and morphs itself to match.
 */
class FreeShippingBar extends HTMLElement {
  /** @type {AbortController | undefined} */
  #activeFetch;

  connectedCallback() {
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
    this.#activeFetch?.abort();
  }

  #onCartUpdate = () => {
    this.#refresh();
  };

  #refresh = () => {
    const sectionId = this.dataset.sectionId;
    const blockId = this.dataset.blockId;

    if (!sectionId || !blockId) return;

    this.#activeFetch?.abort();
    const abortController = new AbortController();
    this.#activeFetch = abortController;

    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    fetch(url, { signal: abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const updated = html.querySelector(`free-shipping-bar[data-block-id="${blockId}"]`);

        if (updated) morph(this, updated);
      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error(error);
      });
  };
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
